<template>
  <v-layout
    row
    align-center
    :style="myLayoutStyle"
  >
    <v-flex
      xs12
      sm10
      offset-sm1
      md10
      offset-md1
      lg10
      offset-lg1
      xl8
      offset-xl2
    >
      <v-card
        flat
        :color="theme.bg_color"
      >
        <v-card-text v-if="this.status === 1">
          <h3 :style="titleStyle">{{ msg }}</h3>
        </v-card-text>
        <v-card-text v-else-if="this.status === 0">
          <h3 :style="titleStyle">{{ $t('payment_fail') }}</h3>
          <v-btn
            block
            dark
            large
            class="btn"
            :color="theme.btn_color_primary"
            @click="checkout"
          >
            <v-layout row>
              <v-flex
                xs12
                class="text-xs-center"
              >
                Go back to checkout
              </v-flex>
            </v-layout>
          </v-btn>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'payment-view',
  metaInfo () {
    return { title: this.$t('payment') }
  },
  data () {
    return {
      msg: null
    }
  },
  computed: {
    ...mapGetters('config', [
      'theme', 'mode', 'gid', 'rid'
    ]),
    ...mapGetters('order', [
      'activeBill'
    ]),
    ...mapGetters('receipt', [
      'receipts'
    ]),
    ...mapGetters('member', [
      'isMember', 'profile'
    ]),
    myLayoutStyle () {
      return {
        marginLeft: '-8px',
        marginRight: '-8px',
        marginBottom: '-16px',
        backgroundColor: this.theme.bg_color
      }
    },
    titleStyle () {
      return {
        color: this.theme.orders_name_color
      }
    },
    status () {
      if (this.$route.query.status) {
        return parseInt(this.$route.query.status)
      }
      return null
    },
    refId () {
      if (this.$route.query.refId) {
        return parseInt(this.$route.query.refId)
      }
      return null
    }
  },
  methods: {
    checkout () {
      this.$router.push({ name: 'bill', params: { id: this.activeBill.tid.toString() } })
    },
    async logData () {
      try {
        let content = { ...this.activeBill, status: this.status, refId: this.refId }
        if (this.isMember) {
          content.member = this.profile
        }
        await axios.post('/api/log', {
          action: 'redirectFromEPay',
          content: content
        })
      } catch (e) { }
    }
  },
  async created () {
    this.logData()
    if (this.status === 1) {
      await this.$store.dispatch('order/resetBill')
      this.msg = this.$t('wait_processing_order')
      // Always use client ref, to prevent another tab's state.activeBill is overriden
      if (this.refId) {
        await this.$store.dispatch('order/fetchActiveBillEpayClientRef', this.refId)
      }
      if (this.activeBill) {
        await this.$store.dispatch('order/addReceiptByClientRef')
        const id = this.activeBill.id
        if (this.isMember) {
          await this.$store.dispatch('member/fetchProfile')
        }
        this.$store.dispatch('order/resetPaymentMode')
        await this.$store.dispatch('order/resetBill')
        if (this.receipts.find(r => parseInt(r.id) === parseInt(id))) {
          this.$router.push({ name: 'receipt', params: { id: id.toString() }})
        } else {
          this.$router.push({ name: 'receipts' })
        }
      } else {
        this.$router.push({ name: 'bills' })
      }
    } else if (this.status === 0) {
      if (this.isMember) {
        await this.$store.dispatch('member/fetchProfile')
      }
    } else {
      this.$router.push({ name: 'menu', params: { gid: this.gid, rid: parseInt(this.rid) }})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/payment2.vue